import { useTranslation } from 'react-i18next';
import { useVeriff } from '@/hooks/shared/useVeriff';
import s from './index.module.scss';

export const VeriffForm = ({ id, user, onSuccess, onClose }) => {
  const { t } = useTranslation();
  useVeriff({
    parentId: id,
    user,
    onSuccess,
    onClose,
  });

  return (
    <div className={s.form}>
      <div className="f-body-sm">{t('veriff:start_verification_message')}</div>
      <ul className={s.list}>
        <li>
          <div className={s.number}>1</div>
          <div className="f-body-sm">
            {t('veriff:prepare_identity_document')}
          </div>
        </li>
        <li>
          <div className={s.number}>2</div>
          <div className="f-body-sm">{t('veriff:check_camera')}</div>
        </li>
        <li>
          <div className={s.number}>3</div>
          <div className="f-body-sm">
            {t('veriff:prepare_photo_and_selfie')}
          </div>
        </li>
      </ul>
      <div className={s.bottom}>
        <div className="f-body-xs">
          {t('veriff:identity_verification_provided_by_veriff')}
        </div>
        <div className="f-body-xs">{t('veriff:media_storage_message')}</div>
      </div>
    </div>
  );
};
